import { observer } from 'mobx-react-lite';
import React from 'react';

import { IListViewProps, ListView } from '../views/ListView';
import { Separator } from '../common/Separator';
import { NotificationItem } from './NotificationItem';
import { Notification } from '@models/Notifications/NotificationModel';

export interface INotificationListProps
  extends Omit<IListViewProps<Notification>, 'renderItem'> {
  data: Notification[];
  onPress(item: Notification): void;
}

export const NotificationList = observer(
  ({ data, onPress, ...props }: INotificationListProps) => {
    return (
      <ListView<Notification>
        keyExtractor={(i) => i.id.toString()}
        data={data}
        renderItem={({ item }) => (
          <NotificationItem item={item} onPress={onPress} />
        )}
        ItemSeparatorComponent={Separator}
        {...props}
      />
    );
  },
);
